export interface Color {
  id?: number;
  name: string;
  description?: string;
  is_active?: boolean;
}

export interface ColorFilters {
  name?: string | '';
  is_active?: boolean | '';
  page: number;
  per_page: number;
  sort: string;
  order: string;
}

export const defaultColorFilters: ColorFilters = {
  page: 1,
  per_page: 10,
  sort: 'id',
  order: 'asc'
};
